import React from "react";
import "./styles/style.css";
import { SectionOne } from "./parts/section-one";
import { SectionTwo } from "./parts/section-two";
import { SectionThree } from "./parts/section-three";
import { SectionSix } from "./parts/section-six";
import {SectionFour} from "./parts/section-four";

const KwikCkeckOutCod = () => {
  return (
    <div className="kwik-checkout">
      <SectionOne />
      <SectionTwo />
      <SectionThree />
      <SectionFour/>
      <SectionSix />
    </div>
  );
};

export default KwikCkeckOutCod;
